import React, { useState, useEffect, useReducer, useCallback, useContext } from "react";
import { toast } from "../../utils/toast";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import ScheduleModal from "../../components/ScheduleModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import BirthdaySettingsModal from "../../components/BirthdaySettingsModal";
import toastError from "../../errors/toastError";
import moment from "moment";
import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "moment/locale/pt-br";
import "react-big-calendar/lib/css/react-big-calendar.css";
import SearchIcon from "@material-ui/icons/Search";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CakeIcon from "@material-ui/icons/Cake";
import Badge from "@material-ui/core/Badge";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import Tooltip from "@material-ui/core/Tooltip";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CheckIcon from "@material-ui/icons/Check";
import ReplayIcon from "@material-ui/icons/Replay";
import ErrorIcon from "@material-ui/icons/Error";
import ScheduleIcon from "@material-ui/icons/Schedule";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

import "./Schedules.css"; // Importe o arquivo CSS

// Defina a funÃ§Ã£o getUrlParam antes de usÃ¡-la
function getUrlParam(paramName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
}

const eventTitleStyle = {
  fontSize: "14px", // Defina um tamanho de fonte menor
  overflow: "hidden", // Oculte qualquer conteÃºdo excedente
  whiteSpace: "nowrap", // Evite a quebra de linha do texto
  textOverflow: "ellipsis", // Exiba "..." se o texto for muito longo
};

const reducer = (state, action) => {
  if (action.type === "LOAD_SCHEDULES") {
    return [...state, ...action.payload];
  }

  if (action.type === "UPDATE_SCHEDULES") {
    const schedule = action.payload;
    const scheduleIndex = state.findIndex((s) => s.id === schedule.id);

    if (scheduleIndex !== -1) {
      state[scheduleIndex] = schedule;
      return [...state];
    } else {
      return [schedule, ...state];
    }
  }

  if (action.type === "DELETE_SCHEDULE") {
    const scheduleId = action.payload;
    return state.filter((s) => s.id !== scheduleId);
  }

  if (action.type === "RESET") {
    return [];
  }

  return state;
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  birthdayEvent: {
    padding: '2px 4px', 
    fontSize: '12px', 
    backgroundColor: theme.palette.primary.main, 
    color: '#fff', 
    borderRadius: '4px'
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  }
  ,
  filterLabel: {
    color: theme.palette.text.primary,
  }
}));

const localizer = momentLocalizer(moment);

const defaultMessages = {
  allDay: 'Dia inteiro',
  previous: 'Anterior',
  next: 'Próximo',
  today: 'Hoje',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  agenda: 'Agenda',
  date: 'Data',
  time: 'Hora',
  event: 'Evento',
  noEventsInRange: 'Não há agendamentos no período.',
  showMore: (total) => `+ ${total} próximo(s)`,
};

const Schedules = () => {
  const classes = useStyles();
  const history = useHistory();

  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [deletingSchedule, setDeletingSchedule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [schedules, dispatch] = useReducer(reducer, []);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(+getUrlParam("contactId"));
  const [birthdaysMap, setBirthdaysMap] = useState({});
  const [displayedDate, setDisplayedDate] = useState(new Date());
  const [initialBody, setInitialBody] = useState("");
  const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
  const [bulkContacts, setBulkContacts] = useState([]);
  const [bulkDate, setBulkDate] = useState(null);
  const [bulkSendAt, setBulkSendAt] = useState("");
  const [bulkMessage, setBulkMessage] = useState("Feliz aniversario, {nome}! Muitas felicidades e um otimo dia.");
  const [showAllYear, setShowAllYear] = useState(false);
  const [showOnlyBirthdays, setShowOnlyBirthdays] = useState(false);
  const [initialSendAt, setInitialSendAt] = useState(null);
  const [periodModalOpen, setPeriodModalOpen] = useState(false);
  const [periodStart, setPeriodStart] = useState(null);
  const [periodEnd, setPeriodEnd] = useState(null);
  const [currentView, setCurrentView] = useState('month');
  const [whatsapps, setWhatsapps] = useState([]);
  const [birthdaySettingsModalOpen, setBirthdaySettingsModalOpen] = useState(false);


  const fetchSchedules = useCallback(async () => {
    try {
      const { data } = await api.get("/schedules/", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_SCHEDULES", payload: data.schedules });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  }, [searchParam, pageNumber]);

  const handleOpenScheduleModalFromContactId = useCallback(() => {
    if (contactId) {
      handleOpenScheduleModal();
    }
  }, [contactId]);

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  // Fetch contacts with birthdays for the month in displayedDate
  useEffect(() => {
    const fetchBirthdays = async () => {
      try {
        const { data: contacts } = await api.get('/contacts/list');
        const map = {};
        // Use month-day key so it works across years displayed in calendar
        contacts.forEach((c) => {
          if (c.birthDate) {
            let bd;
            if (c.birthDate.includes("T")) {
              bd = moment.utc(c.birthDate);
            } else {
              bd = moment(c.birthDate, "YYYY-MM-DD");
            }
            const key = bd.format('MM-DD');
            if (!map[key]) map[key] = [];
            map[key].push(c);
          }
        });
        setBirthdaysMap(map);
      } catch (err) {
        // ignore silently
      }
    };

    fetchBirthdays();
  }, [displayedDate]);

  useEffect(() => {
    const fetchWhatsapps = async () => {
      try {
        const { data } = await api.get('/whatsapp');
        setWhatsapps(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchWhatsapps();
  }, []);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchSchedules();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    contactId,
    fetchSchedules,
    handleOpenScheduleModalFromContactId,
  ]);

  useEffect(() => {
    handleOpenScheduleModalFromContactId();
    const socket = socketManager.getSocket(user.companyId);

    socket.on(`company${user.companyId}-schedule`, (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_SCHEDULES", payload: data.schedule });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_SCHEDULE", payload: +data.scheduleId });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [handleOpenScheduleModalFromContactId, socketManager, user]);

  const cleanContact = () => {
    setContactId("");
  };

  const handleOpenScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(false);
    setInitialBody("");
    setInitialSendAt(null);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleModalOpen(true);
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await api.delete(`/schedules/${scheduleId}`);
      toast.success(i18n.t("schedules.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingSchedule(null);
    setSearchParam("");
    setPageNumber(1);

    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const handleRetrySchedule = async (scheduleId) => {
    try {
      await api.post(`/schedules/${scheduleId}/retry`);
      toast.success("Agendamento reenviado! A mensagem será disparada em instantes.");
      dispatch({ type: "RESET" });
      setPageNumber(1);
      await fetchSchedules();
    } catch (err) {
      toastError(err);
    }
  };

  const openBulkDialog = (date, contacts) => {
    const sendAtDefault = moment(date).hour(9).minute(0).second(0).format("YYYY-MM-DDTHH:mm");
    setBulkDate(date);
    setBulkContacts(contacts);
    setBulkSendAt(sendAtDefault);
    const defaultWhatsapp = whatsapps.find(w => w.isDefault);
    const template = defaultWhatsapp?.complimentMessage || "Feliz aniversario, {nome}! Muitas felicidades e um otimo dia.";
    setBulkMessage(template);
    setBulkDialogOpen(true);
  };

  const closeBulkDialog = () => {
    setBulkDialogOpen(false);
    setBulkContacts([]);
    setBulkDate(null);
  };

  const handleScheduleAllBirthdays = async () => {
    if (!bulkContacts.length || !bulkSendAt) {
      return;
    }

    const template = (bulkMessage || "").trim();
    if (!template) {
      toast.error("Informe uma mensagem para agendar.");
      return;
    }

    setLoading(true);
    const results = await Promise.allSettled(
      bulkContacts.map((contact) => {
        const firstName = (contact.name || "").trim().split(" ")[0] || "Cliente";
        const body = template.replace(/\{nome\}/gi, firstName);

        return api.post("/schedules", {
          body,
          contactId: contact.id,
          sendAt: bulkSendAt,
          userId: user.id,
        });
      })
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failCount = results.length - successCount;

    if (successCount > 0) {
      toast.success(`${successCount} agendamento(s) criado(s) com sucesso.`);
    }
    if (failCount > 0) {
      toast.error(`${failCount} agendamento(s) falharam. Verifique os contatos.`);
    }

    setLoading(false);
    closeBulkDialog();
    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const handleApplyPeriod = () => {
    if (periodStart) {
      setDisplayedDate(moment(periodStart).toDate());
      setCurrentView('agenda');
    }
    setPeriodModalOpen(false);
  };

  const truncate = (str, len) => {
    if (str.length > len) {
      return str.substring(0, len) + "...";
    }
    return str;
  };

  const calendarEvents = [
    ...schedules.map((schedule) => ({
      id: `sched-${schedule.id}`,
      title: schedule.contact.name || "Agendamento",
      start: new Date(schedule.sendAt),
      end: moment(schedule.sendAt).add(1, 'hour').toDate(),
      item: schedule,
    }))
  ];

  Object.keys(birthdaysMap).forEach((dayKey) => {
    const contacts = birthdaysMap[dayKey];
    const year = moment(displayedDate).year();
    const date = moment(`${year}-${dayKey}`, 'YYYY-MM-DD').toDate();
    
    contacts.forEach((c) => {
      const hasSchedule = schedules.some((s) => s.contactId === c.id);
      calendarEvents.push({
         id: `bday-${c.id}`,
         title: `Aniversario: ${c.name}`,
         start: date,
         end: date,
         isAllDay: true,
         item: c,
         hasSchedule,
      });
    });
  });

  const finalEvents = showOnlyBirthdays 
    ? calendarEvents.filter(e => e.id?.startsWith('bday-')) 
    : calendarEvents;

  // If a custom period is selected, filter events to that period (inclusive)
  const eventsInPeriod = (periodStart && periodEnd)
    ? finalEvents.filter(e => {
        const ev = moment(e.start);
        const start = moment(periodStart).startOf('day');
        const end = moment(periodEnd).endOf('day');
        return ev.isBetween(start, end, null, '[]');
      })
    : finalEvents;

  return (
    <MainContainer>
      <ConfirmationModal
        title={
          deletingSchedule &&
          `${i18n.t("schedules.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteSchedule(deletingSchedule.id)}
      >
        {i18n.t("schedules.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <ScheduleModal
        open={scheduleModalOpen}
        onClose={handleCloseScheduleModal}
        reload={fetchSchedules}
        aria-labelledby="form-dialog-title"
        scheduleId={selectedSchedule && selectedSchedule.id}
        contactId={contactId}
        initialBody={initialBody}
        initialSendAt={initialSendAt}
        cleanContact={cleanContact}
      />
      <BirthdaySettingsModal
        open={birthdaySettingsModalOpen}
        onClose={() => setBirthdaySettingsModalOpen(false)}
      />
      <Dialog
        open={bulkDialogOpen}
        onClose={closeBulkDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Agendar aniversario para todos do dia</DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            fullWidth
            variant="outlined"
            label="Data selecionada"
            value={bulkDate ? moment(bulkDate).format("DD/MM/YYYY") : ""}
            disabled
          />
          <TextField
            margin="dense"
            fullWidth
            variant="outlined"
            label="Quantidade de aniversariantes"
            value={bulkContacts.length}
            disabled
          />
          <TextField
            margin="dense"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            label="Mensagem (use {nome} para personalizar)"
            value={bulkMessage}
            onChange={(e) => setBulkMessage(e.target.value)}
          />
          <TextField
            margin="dense"
            fullWidth
            type="datetime-local"
            variant="outlined"
            label="Data e hora do envio"
            value={bulkSendAt}
            onChange={(e) => setBulkSendAt(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeBulkDialog} variant="outlined" color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleScheduleAllBirthdays} variant="contained" color="primary">
            Agendar todos
          </Button>
        </DialogActions>
      </Dialog>
      <MainHeader>
        <Title>{i18n.t("schedules.title")} ({schedules.length})</Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenScheduleModal}
          >
            {i18n.t("schedules.buttons.add")}
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      
      <div className={classes.filterContainer}>
        <FormControlLabel
          control={
            <Switch
              checked={showOnlyBirthdays}
              onChange={(e) => setShowOnlyBirthdays(e.target.checked)}
              color="primary"
            />
          }
          label={<span className={classes.filterLabel}>Mostrar apenas aniversariantes</span>}
        />
        <FormControlLabel
          control={
            <Switch
              checked={showAllYear}
              onChange={(e) => setShowAllYear(e.target.checked)}
              color="primary"
            />
          }
          label={<span className={classes.filterLabel}>Exibir Agenda de todo o ano</span>}
        />
        <Button variant="outlined" onClick={() => setPeriodModalOpen(true)}>
          Selecionar período
        </Button>
        <Button variant="contained" color="secondary" onClick={() => setBirthdaySettingsModalOpen(true)}>
          Config. Aniversários
        </Button>
      </div>

      <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
        <Calendar
          messages={defaultMessages}
          formats={{
            agendaDateFormat: "DD/MM ddd",
            weekdayFormat: "dddd"
          }}
          localizer={localizer}
          events={eventsInPeriod}
          startAccessor="start"
          endAccessor="end"
          date={displayedDate}
          length={
            (periodStart && periodEnd) 
              ? Math.max(1, moment(periodEnd).diff(moment(periodStart), 'days') + 1)
              : (showAllYear ? 365 : 30)
          }
          style={{ height: '700px' }}
          view={currentView}
          onView={(view) => setCurrentView(view)}
          onNavigate={(date, view) => setDisplayedDate(date)}
          views={['month', 'week', 'day', 'agenda']}
           onSelectEvent={(event) => {
            if (event.id && event.id.startsWith('sched-')) {
               handleEditSchedule(event.item);
               setScheduleModalOpen(true);
            } else if (event.id === undefined && event.contact) { 
               // fallback for old structure
               handleEditSchedule(event);
               setScheduleModalOpen(true);
            } else if (event.id && event.id.startsWith('bday-')) {
               const c = event.item;
               const firstName = (c.name || '').split(' ')[0] || c.name;
               const contactWhatsapp = whatsapps.find(w => w.id === c.whatsappId) || whatsapps.find(w => w.isDefault);
               const template = contactWhatsapp?.complimentMessage || "Feliz aniversario, {nome}! Muitas felicidades e um otimo dia.";
               const suggestion = template.replace(/\{nome\}/gi, firstName);
               setInitialBody(suggestion);
               setContactId(c.id);
              // set initial sendAt to birthday date (same year) at 09:00
              const sendAt = moment(event.start).hour(9).minute(0).second(0).format('YYYY-MM-DDTHH:mm');
              setInitialSendAt(sendAt);
              setScheduleModalOpen(true);
            }
          }}
          components={{
            event: (props) => {
              const event = props.event;
              if (event.id && event.id.startsWith('bday-')) {
                return (
                  <div className={classes.birthdayEvent} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>Aniversário: {event.item.name}</span>
                    {event.hasSchedule && (
                      <Tooltip title="Já possui agendamento para este contato">
                        <CheckIcon style={{ fontSize: 16, marginLeft: 4 }} />
                      </Tooltip>
                    )}
                  </div>
                );
              }
              const title = event.item ? event.item.contact.name : event.title;
              const time = moment(event.start).format('HH:mm');
              const status = event.item?.status;

              const statusConfig = {
                'ENVIADA': { icon: <CheckCircleIcon style={{ fontSize: 14 }} />, color: '#2e7d32', bg: 'rgba(46,125,50,0.15)', label: 'Enviada' },
                'ERRO': { icon: <ErrorIcon style={{ fontSize: 14 }} />, color: '#d32f2f', bg: 'rgba(211,47,47,0.15)', label: 'Falhou' },
                'AGENDADA': { icon: <HourglassEmptyIcon style={{ fontSize: 14 }} />, color: '#ed6c02', bg: 'rgba(237,108,2,0.15)', label: 'Enviando...' },
                'PENDENTE': { icon: <ScheduleIcon style={{ fontSize: 14 }} />, color: '#1976d2', bg: 'rgba(25,118,210,0.15)', label: 'Pendente' },
              };

              const cfg = statusConfig[status];

              return (
                <div className="event-container" style={{ display: 'flex', alignItems: 'center', padding: '2px 4px', fontSize: '12px' }}>
                  {cfg ? (
                    <Tooltip title={cfg.label}>
                      <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: '3px',
                        background: cfg.bg, color: cfg.color, borderRadius: '999px',
                        padding: '1px 6px', marginRight: '6px', fontWeight: 600, fontSize: '11px'
                      }}>
                        {cfg.icon}
                      </div>
                    </Tooltip>
                  ) : (
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#005c4b', marginRight: '6px' }}></div>
                  )}
                  <strong style={{ opacity: 0.8, marginRight: '4px' }}>{time}</strong>
                  <div style={eventTitleStyle}>{title}</div>
                  {status === 'ERRO' && (
                    <Tooltip title="Tentar novamente">
                      <ReplayIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRetrySchedule(event.item.id);
                        }}
                        className="edit-icon"
                        style={{ fontSize: 16, color: '#d32f2f' }}
                      />
                    </Tooltip>
                  )}
                  <DeleteOutlineIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteSchedule(event.item ? event.item.id : event.id);
                    }}
                    className="delete-icon"
                    style={{ fontSize: 16 }}
                  />
                  <EditIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditSchedule(event.item || event);
                      setScheduleModalOpen(true);
                    }}
                    className="edit-icon"
                    style={{ fontSize: 16 }}
                  />
                </div>
              );
            },
            dateCellWrapper: (props) => {
              const value = props.value;
              const dayKey = moment(value).format('MM-DD');
              const items = birthdaysMap[dayKey] || [];
              return (
                <div style={{ position: 'relative' }}>
                  {props.children}
                  {items.length > 0 && (
                    <div className="birthday-badge" onClick={(e) => {
                      e.stopPropagation();
                      openBulkDialog(value, items);
                    }}>
                      <Badge badgeContent={items.length} color="secondary">
                        <CakeIcon style={{ fontSize: 16, color: 'var(--primary)' }} />
                      </Badge>
                    </div>
                  )}
                </div>
              );
            }
          }}
        />
      </Paper>
      <Dialog open={periodModalOpen} onClose={() => setPeriodModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Selecionar período</DialogTitle>
        <DialogContent>
          <TextField
            label="Data inicial"
            type="date"
            fullWidth
            value={periodStart ? moment(periodStart).format('YYYY-MM-DD') : ''}
            onChange={(e) => setPeriodStart(e.target.value ? moment(e.target.value).toDate() : null)}
            InputLabelProps={{ shrink: true }}
            margin="dense"
          />
          <TextField
            label="Data final"
            type="date"
            fullWidth
            value={periodEnd ? moment(periodEnd).format('YYYY-MM-DD') : ''}
            onChange={(e) => setPeriodEnd(e.target.value ? moment(e.target.value).toDate() : null)}
            InputLabelProps={{ shrink: true }}
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setPeriodModalOpen(false); }} variant="outlined" color="secondary">Cancelar</Button>
          <Button onClick={handleApplyPeriod} variant="contained" color="primary">Aplicar</Button>
        </DialogActions>
      </Dialog>
    </MainContainer>
  );
};

export default Schedules;
